import React, {useEffect, useState} from "react";

import Filters from "./filters/Filters";
import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";
import {useStore} from "../../hooks/useStore";
import {useFetch} from "../../hooks/useFetch";
import {message, Row} from "antd";
import {useHistory} from "react-router-dom";
const Payments = () => {
    const stores = useStore();
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        subCompanyId: undefined
    });
    const [loading, payments] = useFetch({
        fetchFn: stores.companyStore.listPayments.bind(null, {
            subCompanyId: filters.subCompanyId,
            limit: 10,
            page: currentPage
        }),
        dependencies: [filters, currentPage],
        condition: Boolean(filters.subCompanyId)
    });

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const status = urlParams.get("status");

        if (!stores.meStore.checkRole("isUatPoolCustomer")) {
            if (status === "success") {
                message.success("Ödemeniz başarıyla gerçekleşti. Bakiyeniz güncellendi.");
            } else if (status === "fail") {
                message.error("Ödemeniz gerçekleştirilemedi. Lütfen tekrar deneyin.");
            }
        } else {
            history.push(`/musteri?status=${status}`);
        }
    }, []);

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row justify="end">
                <ActionButtons filters={filters} />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={payments?.result || []}
                    dataCount={payments?.total || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};
export default Payments;
